<template>
  <div>
    <el-row>
      <el-col v-if="isEdit" :span="15">
        <el-button size="mini" type="primary" @click="handleAddLine">+ Add Line</el-button>
        <el-button
          size="mini"
          type="warning"
          plain
          @click="handleDeleteLine"
          :disabled="!lineSelected"
        >Delete Line</el-button>
        <el-button
          size="mini"
          type="success"
          plain
          @click="handleCopyLine"
          :disabled="!lineSelected"
        >Copy Line</el-button>
        <el-upload
          :headers="uploadHeader"
          action="/api/app/lines"
          :limit="1"
          :on-success="handleLineImported"
          accept="xls"
          :style="{'margin-left': '8px'}"
        >
          <el-button size="mini" type="info" plain>Import Lines</el-button>
        </el-upload>
      </el-col>
      <el-col :span="9" :offset="isEdit? 0 : 15">
        <div class="item-upper-lines-static-texts">
          <span v-show="showForOrderType123457">
            <span>Currency&nbsp;</span>
            <span class="strong">AUD</span>
          </span>
          <span v-show="showForOrderType12">
            <span>Line Amount Tax&nbsp;</span>
            <span class="strong">INCLUSIVE</span>
          </span>
          <span v-show="showForOrderType12">
            <span>Line Account Code&nbsp;</span>
            <span class="strong">200 - Sales</span>
          </span>
          <span v-show="showForOrderType345">
            <span>Line Account Code&nbsp;</span>
            <span class="strong">630 - Inventory</span>
          </span>
        </div>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-table
      ref="multipleTable"
      border
      stripe
      :data="tableData"
      style="width: 100%"
      :row-style="{height:'40px'}"
      size="mini"
      :header-cell-style="{background:'#D7D7D7',color:'#000'}"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column v-if="isEdit" type="selection" width="40" align="center"></el-table-column>
      <el-table-column type="index" width="45" align="center"></el-table-column>
      <el-table-column width="1">
        <template v-slot="scope">
          <input type="hidden" />
        </template>
      </el-table-column>

      <ElementCratorTable v-for="c in config" :key="c.hash" :config="c" />
    </el-table>
    <el-divider></el-divider>
    <el-row v-if="isEdit">
      <el-col :span="9">
        <el-button size="mini" type="primary" @click="handleAddLine">+ Add Line</el-button>
        <el-button
          size="mini"
          type="warning"
          plain
          @click="handleDeleteLine"
          :disabled="!lineSelected"
        >Delete Line</el-button>
        <el-button
          size="mini"
          type="success"
          plain
          @click="handleCopyLine"
          :disabled="!lineSelected"
        >Copy Line</el-button>
        <el-upload
          action="/api/app/lines"
          :limit="1"
          accept="xls"
          :headers="uploadHeader"
          :on-success="handleLineImported"
          :style="{'margin-left': '8px'}"
        >
          <el-button size="mini" type="info" plain>Import Lines</el-button>
        </el-upload>
      </el-col>
      <EditDetailFooter :isEdit="isEdit" />
    </el-row>
    <el-row v-else>
      <EditDetailFooter :isEdit="isEdit" />
    </el-row>
  </div>
</template>

<script>
// import BillHistory from './BillHistory'
// import ColumnStockDropDown from './ColumnStockDropDown'
// import ColumnAddToCart from './ColumnAddToCart'
import { mapState, mapMutations, mapActions } from 'vuex'

import ElementCratorTable from './ElementCratorTable'
import EditDetailFooter from './EditDetailFooter'
import { uuid } from '../utils'

export default {
  name: 'OrderLinesEdit',
  components: {
    ElementCratorTable,
    EditDetailFooter
  },
  data () {
    return {
      lineSelected: false
    }
  },
  props: {
    config: {
      type: Array,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('edit', {
      tableData: 'lines',
      orderType: 'type'
    }),
    ...mapState('oauth', ['accessToken']),
    ...mapState(['currentAccount']),
    emptyInfo () {
      return this.isNewEnter ? 'Enter CRS or Item Key to Search' : 'No Data'
    },
    showForOrderType12 () {
      return this.orderType <= 2
    },
    showForOrderType123457 () {
      return this.orderType <= 5 || this.orderType === 7
    },
    showForOrderType345 () {
      return this.orderType === 3 || this.orderType === 4 || this.orderType === 5
    },
    uploadHeader () {
      return {
        // 'Content-type': 'application/json',
        Authorization: this.accessToken,
        'IWE-EID': this.currentAccount.eId
      }
    }
  },
  methods: {
    ...mapMutations({
      handleAddLine: 'edit/newLine',
      addLine: 'edit/addLine'
    }),
    ...mapActions({
      copyLines: 'edit/copyLines',
      deleteLines: 'edit/deleteLines'
    }),

    handleSelectionChange (selection) {
      this.lineSelected = selection.length > 0
    },
    handleDeleteLine () {
      const ids = this.$refs.multipleTable.selection.map(sel => sel.id)
      if (ids.length === 0) {
        return
      }

      this.deleteLines(ids)
    },
    handleCopyLine () {
      const ids = this.$refs.multipleTable.selection.map(sel => sel.id)
      if (ids.length === 0) {
        return
      }
      this.copyLines(ids)
      this.$refs.multipleTable.clearSelection()
    },
    handleLineImported (response) {
      response.data.forEach(l => {
        const line = {
          id: 'new_' + uuid(),
          quantity: l.quantity || 0,
          inWarehouseQty: l.inWarehouseQty || 0,
          inSystemQty: l.inSystemQty || 0,
          price: l.price || 0,
          line_amount: l.amount || 0,
          desc: l.description || '',
          product: l.product,
          unit: l.unit
        }
        this.addLine(line)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-btn-container {
  display: inline-block;
  margin-left: 8px;
}
.el-divider {
  margin: 8px 0;
  background-color: #eff2f8;
}
.item-lines-footer-texts {
  background-color: #e0e0e03f;
}
.text-title-bold {
  display: inline-block;
  height: 100%;
  margin-left: 55px;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.text-title {
  margin-left: 40px;
}
.text-number {
  display: inline-block;
  width: 70px;
  margin-left: 8px;
  margin-right: 30px;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  color: #cc3300;
}
.text-small-number {
  display: inline-block;
  margin-left: 8px;
  font-weight: bold;
  color: #cc8067;
}
.price-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
